import { render, staticRenderFns } from "./psuForm.vue?vue&type=template&id=5cbb6a91&scoped=true"
import script from "./psuForm.vue?vue&type=script&lang=js"
export * from "./psuForm.vue?vue&type=script&lang=js"
import style0 from "./psuForm.vue?vue&type=style&index=0&id=5cbb6a91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbb6a91",
  null
  
)

export default component.exports